module.exports = __webpack_public_path__ + "img/img4.31a5c6d9.jpg";